import React, { useState, useRef, useEffect } from 'react';
import LeadBuilder from './LeadBuilder';
import DisplayPage from './DisplayPage';
import { CSVLink } from "react-csv";
import {Button} from "@material-ui/core";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import '../../App.css'

const ParentComponent = (props) => {
  const csvButtonRef = useRef(null);
  const [renderData, setRenderData] = useState([]);
  const [heading, setHeading] = useState('Expand Lead Builder')
  const [expanded, setExpanded] = useState(false);

const setHeadingFun = (e,v)=>{
  setExpanded(!expanded)

  if(!v){
    setHeading('Expand Lead Builder')
  }
  else{
    setHeading('Collapse Lead Builder')
  }
}

    useEffect(()=>{
    },[renderData])

  return (
    <div className='tableContainer'>

      <Accordion expanded={expanded}
          onChange={setHeadingFun}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="h6">{heading}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <LeadBuilder setRenderData={setRenderData} />
        </AccordionDetails>
      </Accordion>

      <DisplayPage renderData={renderData} />
    </div>
  );
};

export default ParentComponent;